import {ViewOrderItems} from 'app/features/orders/componentsv1'
import {orderFulfillmentStatusTypes} from 'app/features/orders/models'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {formatToMMDDYYYYv1} from 'app/format/date'
import _ from 'lodash'

interface Props {
  order: ViewOrder
}

export const ViewRefundLineItems: React.FC<Props> = ({order}) => {
  if (
    (order.refundItems && order.refundItems.length === 0) ||
    order.fulfillmentStatus === orderFulfillmentStatusTypes.restocked
  ) {
    return null
  }

  return (
    <>
      {order.refundItems &&
        order.refundItems
          .filter((refund) => refund.refundItems.nodes.length > 0)
          .map((refund) => {
            return (
              <ViewOrderItems
                items={mapToRefundItemsModel(refund.refundItems.nodes)}
                title={`Refunded - ${formatToMMDDYYYYv1(refund.createdAt)}`}
                isShowStatus
              />
            )
          })}
    </>
  )
}

export default ViewRefundLineItems

const mapToRefundItemsModel = (orderItems: any[]) => {
  return _.filter(orderItems, ({quantity}) => quantity > 0).map(({price, variant, quantity}) => {
    const {product} = variant
    return {
      ...variant,
      quantity,
      variant: variant.name,
      price: parseFloat(price),
      totalPrice: parseInt(quantity) * parseFloat(price),
      product,
      status: orderFulfillmentStatusTypes.restocked,
    }
  })
}
